// extracted by mini-css-extract-plugin
export default {"contents":"rH-z","sectionHeading":"sH-z"};